export default __webpack_public_path__ + "static/media/services.cac2d476.webm";